module.exports = __webpack_public_path__ + "static/media/SG_yellow.ed9ed4eb.png";